import { z } from "zod";

export const ZCampaigns = z.object({
  nombre: z.string(),
  template_id: z.string(),
  estado: z.string(),
  fecha_envio: z.string().optional(),
  activo: z.union([z.string(), z.number()]).optional(),
});

